import { AppEmcResponse, ApplicationResponse } from '@models/api-calls/application/application-response.model';
import { Beneficiary, InsuredClient } from '@models/api-calls/clients/client.model';

export interface Application extends Pick<ApplicationResponse, 'id' | 'guid' | 'dashboard_policy_id' | 'insured_client_id'> {
    insured_client: InsuredClient | null;
    app_emc: EmcApplication;
    beneficiaries: Beneficiary[];
}

export interface EmcApplication
    extends Pick<
        AppEmcResponse,
        | 'id'
        | 'has_fraud_notice'
        | 'has_statements_and_agreements'
        | 'emc_risk'
        | 'emc_product_group_type'
        | 'has_existing_insurances'
        | 'existing_insurances_applied'
        | 'medical_consent'
        | 'emc_edelivery_opt_in'
        | 'emc_edelivery_consent'
        | 'emc_edelivery_consent_version'
        | 'uw_at'
    > {}

export enum EmcProductGroupTypes {
    MORTGAGE = 'mortgage',
}

export enum ActorType {
    INSURED = 'insured',
    BENEFICIARY = 'beneficiary',
    PRIMARY_PAYER = 'primary_payer',
    SECONDARY_PAYER = 'secondary_payer',
    PAYER_CONTACT = 'payer_contact',
    OWNER = 'owner',
}
